'use strict';
import { ResetPasswordBase } from './ResetPasswordBase';
import Render from './ResetPasswordRender';

export default class ResetPassword extends ResetPasswordBase {
    render() {
        return Render.call(this, this.props, this.state);
    }
}
